import { Observable } from 'rxjs';
import { TableColumn, IdentifierTableColumn, RadioComponent, SelectDialogComponent, CheckboxComponent } from '@serengeti/serengeti-common';
import { MatDialog } from '@angular/material/dialog';

export class VariableValueBrowser {
    public dialog: MatDialog;
    public keyColumn: TableColumn;
    public textColumn: TableColumn;
	public apiNames: any[];

    public constructor(dialog: MatDialog, apiNames: any[]) {
        this.dialog = dialog;
		this.apiNames = apiNames;
    }

	public browse(variable: any, value?: string, title?: string): Observable<any> {
		const columns = [] as TableColumn[];

		variable.apiColumns.columns.forEach((column: any) => {
			if (column.id) {
				if (variable.apiColumns.multiple) {
					columns.push(this.keyColumn = new IdentifierTableColumn(column.key, '', false)
					.withHeaderCheck(true)
					.withIgnoreSort(true)
					.withType(CheckboxComponent));
				} else {
					columns.push(this.keyColumn = new IdentifierTableColumn(column.key, column.name, false).withType(RadioComponent));
				}
			} else if (column.text) {
				columns.push(this.textColumn = new TableColumn(column.key, column.name));
			} else {
				columns.push(new TableColumn(column.key, column.name));
			}
		});

        let apiUrl = variable.apiUrl;
        let apiHost = null;

        for (const apiName of this.apiNames) {
            if (variable.apiName === apiName.id) {
                apiHost = apiName.host;
                break;
            }
        }
        apiUrl = apiHost + apiUrl;

		if (variable.associates && variable.associates.length > 0) {
			for (const associate of variable.associates) {
                apiUrl = apiUrl.replace('\{' + associate.variableName + '\}', associate.variableValue);
                // apiUrl = apiUrl.replace(associate.variableName, associate.variableValue);
            }
        }
		
		const dialogRef = this.dialog.open(SelectDialogComponent, {
			width: '1000px',
			height: '800px',
			data: {
				title: variable.name + (title ? title : ''),
				query: apiUrl,
				method: variable.apiMethod.toLowerCase(),
				selectedItems: (this.isJson(value) ? JSON.parse(value) : (value ? [ value ] : [])),
				columns: columns
			}
		});

		return dialogRef.afterClosed();
	}

	isJson(str: string): boolean {
		try {
			JSON.parse(str);
			return true;
		} catch (e) {
			return false;
		}
	}

	public getValue(variable: any, resultData: any[]): string {
		let apiColumns = variable.apiColumns;

		if (apiColumns) {
			if (typeof apiColumns !== 'object') {
				apiColumns = JSON.parse(variable.apiColumns);
			}
			if (apiColumns.multiple) {
				const variableValue = [];
	
				resultData.forEach((item: any) => {
					const value = this.keyColumn.getContent(item);
	
					variableValue.push(value);
				});
				return JSON.stringify(variableValue);
			} else {
				const variableValue = resultData[0];
	
				return this.keyColumn.getContent(variableValue);
			}
		} else {
			return null;
		}
	}

	public getText(variable: any, resultData: any[]): string {
		let apiColumns = variable.apiColumns;

		if (apiColumns) {
			if (typeof apiColumns !== 'object') {
				apiColumns = JSON.parse(variable.apiColumns);
			}
			let variableText = '';

			if (apiColumns.multiple) {
				const variableValue = [];

				resultData.forEach((item: any) => {
					const value = this.keyColumn.getContent(item);

					variableValue.push(value);
					if (variableText !== '') {
						variableText += ',';
					} 
					if (this.textColumn != null) {
						variableText += this.textColumn.getContent(item);
					} else {
						variableText += value;
					}
				});
				variable.variableValue = JSON.stringify(variableValue);
			} else {
				const variableValue = this.keyColumn.getContent(resultData[0]);
				if (this.textColumn != null) {
					variableText = this.textColumn.getContent(resultData[0]);
				} else {
					variableText = variable.variableValue;
				}	
			}
			return variableText;
		} else {
			return null;
		}
	}
}
